/* eslint-disable */
import React from 'react';
import { compose, setPropTypes, setDisplayName, lifecycle } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import rpCookie from 'rp-cookie';
import { subscriptionAddSuccess } from '../../../../actions/payment';
import { subscriptionConfirm } from '../../../../actions/subscriptions';
import { getServicePriceId, serviceIdSelector } from '../../../../selectors';

export default compose(
    setDisplayName('PaymentDetails'),
  connect(state => ({
      serviceId: serviceIdSelector(state),
      servicePriceId: getServicePriceId(state),
  }), { subscriptionAddSuccess, subscriptionConfirm }),
    lifecycle({
        componentDidMount() {
            this.props.subscriptionConfirm({
                sessionId: this.props.sessionId || rpCookie.sharedPermanent.get('rp_guid'),
                priceId: this.props.servicePriceId,
                returnUrl: `//${global.location.host}/subscriptions/confirm`,
                voucherCode: this.props.voucherCode,
            });
        },
    }),
    setPropTypes({
        subscriptionAddSuccess: PropTypes.func.isRequired,
    }),
)(() => null);
